<template>
  <v-dialog v-model="value" width="500" persistent>
    <v-card class="w-100 rounded-lg">
      <v-card-title>{{ $t('spedilink.offers.unsubscribeTitle') }}</v-card-title>
      <v-card-text>
        <p>
          {{ $t('spedilink.offers.unsubscribeConfirm') }}
          <strong>{{ offer.name }}</strong>?
        </p>
        <p class="error--text mb-0">{{ $t('spedilink.offers.unsubscribeWarning') }}</p>
      </v-card-text>
      <v-card-actions class="d-flex justify-end px-4 pb-4">
        <v-btn outlined :disabled="loading" @click="$emit('close')">
          {{ $t('common.cancel') }}
        </v-btn>
        <v-btn
          color="error"
          class="ml-2"
          depressed
          :loading="loading"
          :disabled="loading"
          @click="unsubscribe()"
        >
          {{ $t('spedilink.offers.unsubscribe') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Service from '@/services'

export default {
  name: 'UnsubscribeFromListDialog',
  props: {
    value: {
      type: Boolean,
      required: true
    },
    offer: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      loading: false
    }
  },
  methods: {
    async unsubscribe () {
      this.loading = true
      try {
        await Service.post('spedilink/SpediLinkOffers/Resign', {
          SpediLinkId: this.offer.id
        })
        await this.$store.dispatch('setSuccessNotification', this.$t('spedilink.offers.unsubscribeSuccess'))
        this.$emit('unsubscribed')
      } catch (e) {
        const message = e?.response?.data?.Title || e?.response?.data?.title
        if (message) {
          await this.$store.dispatch('setErrorNotification', message)
        }
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
